import { createSelector } from 'reselect';
import { getFormattedRouterMatchParams } from 'selectors/router';
import { getLocaleUrlPath } from 'utils';
import { PRODUCT_TYPES, CLIENT_TYPES } from 'constants/index';
export var getDefaultBreadcrumbs = createSelector(getFormattedRouterMatchParams, function (state, props) {
  return props.intl;
}, function (state) {
  return state.organizations;
}, function (_ref, _ref2, _ref3) {
  var _organization$organiz, _organization$organiz2;

  var organizationSlug = _ref.organizationSlug,
      clientType = _ref.clientType,
      page = _ref.page;
  var locale = _ref2.locale,
      formatMessage = _ref2.formatMessage;
  var organization = _ref3.organization;
  var urlLocale = getLocaleUrlPath(locale);
  var routerBasename = "".concat(urlLocale).concat(process.env.APP_ROUTER_BASENAME);
  var isRvkPage = !!organizationSlug;
  var isFopPage = page === PRODUCT_TYPES.fop && !isRvkPage;
  var isItPage = clientType === CLIENT_TYPES.it;
  var organizationName = (_organization$organiz = organization[organizationSlug]) == null ? void 0 : (_organization$organiz2 = _organization$organiz.data) == null ? void 0 : _organization$organiz2.nameP;
  var defaultBreadcrumbs = [{
    name: formatMessage({
      id: 'breadcrumbs.mainPage'
    }),
    link: urlLocale
  }, {
    name: formatMessage({
      id: 'breadcrumbs.rkoPage'
    }),
    link: routerBasename
  }, isItPage ? {
    name: formatMessage({
      id: 'breadcrumbs.itPage'
    }),
    link: "".concat(routerBasename, "/").concat(organizationSlug, "it/")
  } : null, isFopPage ? {
    name: formatMessage({
      id: 'breadcrumbs.fopPage'
    }),
    link: "".concat(routerBasename, "/").concat(PRODUCT_TYPES.fop)
  } : null, isRvkPage ? {
    name: formatMessage({
      id: 'breadcrumbs.rvkPage'
    }, {
      bank: organizationName
    }),
    link: "".concat(routerBasename, "/").concat(organizationSlug)
  } : null];
  return defaultBreadcrumbs.filter(Boolean);
});